import { useEffect, useRef } from 'react';

export default function SLThumbnail({ src, alt, className }) {
    const canvasRef = useRef(null);

    useEffect(() => {
        if (!src) return;
        const canvas = canvasRef.current;
        if (!canvas) return;

        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
            const fullW = img.naturalWidth;
            const halfW = Math.floor(fullW / 2);
            const h = img.naturalHeight;
            if (!halfW || !h) return;

            const tmp = document.createElement('canvas');
            tmp.width = fullW;
            tmp.height = h;
            const tctx = tmp.getContext('2d');
            tctx.drawImage(img, 0, 0);
            const fill = tctx.getImageData(0, 0, halfW, h);
            const key = tctx.getImageData(halfW, 0, halfW, h);
            const fd = fill.data;
            const kd = key.data;
            for (let i = 0; i < fd.length; i += 4) {
                fd[i + 3] = kd[i];
            }

            canvas.width = halfW;
            canvas.height = h;
            canvas.getContext('2d').putImageData(fill, 0, 0);
        };
        img.src = src;

        return () => {
            img.onload = null;
        };
    }, [src]);

    return (
        <div
            className={`h-24 rounded flex-shrink-0 overflow-hidden checkered-bg ${className ? className : ''}`}
            style={{ aspectRatio: '8 / 9' }}
        >
            <canvas
                ref={canvasRef}
                role="img"
                aria-label={alt}
                className="w-full h-full object-contain"
            />
        </div>
    );
}
